import { Enum  } from "./Enum";

export const SupplierTypeEnum: Enum[] = [
  { id: 'general', name: 'General' },
  { id: 'promo', name: 'Promo' }
];